module.exports = __webpack_public_path__ + "static/img/avatar.edb26de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/avatar.jpg
// module id = RQLd
// module chunks = 1